import { type SidebarSection } from '@frontends/ds';
import { type TFunction } from 'i18next';

export const PATHS = {
  login: '/login',
  instances: '/instances',
  bots: '/bots',
  channels: '/channels',
  entryFlows: '/entry-flows',
  newEntryFlow: '/entry-flows/new',
  retentionRules: '/retention-rules',
  newRetentionRule: '/retention-rules/new',
} as const;

export function getSidebarSections(t: TFunction): SidebarSection[] {
  return [
    {
      id: 'main',
      items: [
        { id: 'instances', label: t('nav.instances'), icon: 'layers', href: PATHS.instances },
        { id: 'bots', label: t('nav.bots'), icon: 'bot', href: PATHS.bots },
        { id: 'channels', label: t('nav.channels'), icon: 'hash', href: PATHS.channels },
        { id: 'entry-flows', label: t('nav.entryFlows'), icon: 'workflow', href: PATHS.entryFlows },
        { id: 'retention-rules', label: t('nav.retentionRules'), icon: 'shield-check', href: PATHS.retentionRules },
      ],
    },
  ];
}
